<script>
export default {
  name: "ShowView",
  data() {
    return {
      url: "",
      number: 0,
      title: ""
    }
  },
  created() {
    this.url = decodeURIComponent(this.$route.query.url);
    this.number = this.$route.query.number;
    if (1 == this.number) {
      this.title = "检测报告";
    }else if (2 == this.number) {
      this.title = "产品展示";
    }
  },
  methods: {}
}
</script>
<template>
  <div class="show">
    <div class="title">
      {{ this.title }}
    </div>
    <van-image v-bind:src="url"/>
  </div>
</template>
<style scoped>
.show {
  width: 100vw;
  height: 100vh;
  overflow-y: scroll;
}

.title {
  background-color: #1A7AF8;
  font-weight: bold;
  text-align: center;
  color: white;
  font-size: 1.25rem; /* 使用相对单位更好适配 */
  color: white;
  padding: 20px 0;
}
</style>